import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const minlengthNumberValidator = (min: number): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const valueAsString = value.toString();
    if (valueAsString.length < min) {
      return { minLengthNumber: true };
    }

    return null;
  };
};
